import SearchResult from '@/core/search/SearchResult';

export default class DonorSearchResult extends SearchResult {
}
